export default "__VITE_ASSET__DIdgE29x__"